import React, {useEffect, useState} from 'react';
import styled from 'styled-components'

export default function Paginator(props) {
    if(props.total === 0) return null;
    return(
        <Container>
            <Button onClick={props.onPrev}>Anterior</Button>
            <Pages>{props.current} / {props.total}</Pages>
            <Button onClick={props.onNext}>Siguiente</Button>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    margin: 12px 0;

`
const Pages = styled.div`
 padding: 8px;
 color: white;
 margin: 4px 0;

`
const Button = styled.div`
    flex: 1;
    padding: 8px;
    margin: 4px;
    border-radius: 8px;
    &:hover {
        background-color: #5F676D;
        color: black;
    }
    cursor: pointer;
    text-align: center;
`
